import Loader from '@superfunnel/ui-core/Loader';
import { useCallback } from 'react';
import ChartsGrid from '../../components/Overview/ChartsGrid';
import { useDynamicPageContext } from '../../contexts/DynamicPageContext';

export default function MainAnalytics() {
  const { selectedDynamicPage, analyticsConfig, variants, analyticsFilters } =
    useDynamicPageContext();

  const translateSegmentLabel = useCallback(
    (segment: string | undefined, value: string): string => {
      if (!segment) return value;

      // Translate campaignId to campaign name (dynamic page name)
      if (segment === 'variantId') {
        const variant = variants?.find((variant) => variant.id === value);
        return variant?.data().name || value;
      }

      return value;
    },
    [variants],
  );

  if (!selectedDynamicPage) {
    return <Loader />;
  }

  return (
    <ChartsGrid
      config={analyticsConfig}
      analyticsFilters={analyticsFilters}
      campaignId={selectedDynamicPage?.id}
      translateSegmentLabel={translateSegmentLabel}
    />
  );
}
